import { AEMOptions } from "@AEM/models/AEMPage.model"
import { AEMPageType } from "@AEM/models/AEMPage.model"
import { UseQueryResult } from "@tanstack/react-query"
import { useAEMContent } from "./useAEMContent"
import { createSettingsMapper } from "@AEM/AEMContentMapper"
import { AEMAppSetting } from "@AEM/models/AEMResponse.model"

export enum AEM_APP_SETTINGS_COLLECTIONS {
	SHIP_NAV_CONFIG = "shipNavConfig",
	REGISTRATION = "registration",
	GLOBAL = "global",
	TRADE_SITES_NAV_CONFIG = "tradeSitesNavConfig",
	FODORS_CONFIG = "fodorsConfig"
}

export const useAEMAppSettings = (
	appSettingsId: AEM_APP_SETTINGS_COLLECTIONS,
	options?: AEMOptions
) => {
	const { data, isLoading, error, refetch } = useAEMContent(
		AEMPageType.APP_SETTINGS,
		{ ...options, pathParams: [appSettingsId], mapper: createSettingsMapper() }
	) as UseQueryResult<AEMAppSetting>
	const settingsData = data
	return { settingsData, isLoading, error, refetch }
}
